<template>
	<div>
		<a href="javascript:void(0)" class="uk-navbar-item uk-padding-small">
			<span v-show="label">{{ label }}</span>
			<span class="material-symbols-outlined">share</span>
		</a>
		<div uk-dropdown="mode: click">
			<ul class="uk-nav uk-dropdown-nav">
  			<li><a href="javascript:void(0)" @click="shareOnFacebook"><span uk-icon="icon: facebook" class="uk-margin-small-right"></span> Facebook</a></li>
  			<li><a href="javascript:void(0)" @click="shareOnTwitter"><span uk-icon="icon: twitter" class="uk-margin-small-right"></span>Twitter</a></li>
  			<li><a href="javascript:void(0)" @click="shareOnLinkedIn"><span uk-icon="icon: linkedin" class="uk-margin-small-right"></span>LinkedIn</a></li>
  			<li><a :href="emailLink"><span uk-icon="icon: mail" class="uk-margin-small-right"></span> Email</a></li>
  			<li><a href="javascript:void(0)" @click="copyToClipboard"><span uk-icon="icon: link" class="uk-margin-small-right"></span> Link kopiëren</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
  props: {
		siteName: {
      type: String,
			default: '',
      required: true
		},
    url: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
		mailto: {
			type: String,
			required: true,
			default: 'info@site.com'
		},
		label: {
			type: String,
			required: false
		}
  },
  mounted() {
  },
  computed: {
    emailLink() {
      const subject = encodeURIComponent(`Bekijk dit artikel op ${this.siteName}`);
      const body = encodeURIComponent(`${this.title}:\n${this.url}`);
      return `mailto:${this.mailto}?subject=${subject}&body=${body}`;
    }
  },
  methods: {
    shareOnFacebook() {
      const url = encodeURIComponent(this.url);
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
    },
    shareOnTwitter() {
      const url = encodeURIComponent(this.url);
      const title = encodeURIComponent(this.title);
      window.open(`https://twitter.com/intent/tweet?url=${url}&text=${title}`, '_blank');
    },
    shareOnLinkedIn() {
      const url = encodeURIComponent(this.url);
      const title = encodeURIComponent(this.title);
      window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`, '_blank');
    },
    copyToClipboard() {
      const urlInput = document.createElement('input');
      urlInput.value = this.url;
      document.body.appendChild(urlInput);
      urlInput.select();
      document.execCommand('copy');
      document.body.removeChild(urlInput);

      UIkit.notification({
        message: 'URL naar je clipboard gekopiëerd',
        status: 'success',
				pos: 'bottom-center'
      });

    }
  }
}
</script>
